<template>
    <span class="lot-badge" :class="'lot-badge--' + renderBadgeClass(id)">{{
        renderBadgeTitle(id)
    }}</span>
</template>

<script>
export default {
    props: {
        id: Number | String,
    },
    methods: {
        renderBadgeClass(id) {
            switch (id) {
                case 3:
                    return "free";
                case 2:
                    return "reserved";
                case 1:
                    return "sold";
                default:
                    return "free";
            }
        },
        renderBadgeTitle(id) {
            switch (id) {
                case 3:
                    return "Voľný";
                case 2:
                    return "Rezervovaný";
                case 1:
                    return "Predaný";
                default:
                    return "Voľný";
            }
        },
    },
};
</script>
